export default "__VITE_ASSET__GDlSAqwe__"